export const LOAD_CAMPAIGN_PROFILE = 'load_campaign_profile';
export const UPDATE_CAMPAIGN_PROFILE = 'update_campaign_profile';
export const GET_TARGET_PRESSURE = 'get_target_pressure';
export const GET_FRAGMENT_DATA = 'get_fragment_data';
export const SET_CAMPAIGN_TEAMS = 'set_campaign_teams';
export const CREATE_CAMPAIGN_CONVERSATION = 'create_campaign_conversation';
export const SET_MESSAGE_DETAILS = 'set_message_details';
export const SET_CHANNEL_DETAILS = 'set_channel_details';
export const SET_CAMPAIGN_OWNER = 'set_campaign_owner';